    <div class="low-navbar-account">
        <ul>
            @for(item of navItems; track item.item){
                <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
                    <a (click)="triggerAction(item.item)">{{ item.name }}</a>
                </li>
            }
        </ul>
        <hr>
    </div>
    <app-activities *ngIf="navItems[0].active"></app-activities>
    <app-gest-com *ngIf="navItems[1].active" [contacto]="contacto"></app-gest-com>
    <app-con-camp *ngIf="navItems[2].active" [contacto]="contacto"></app-con-camp>
    <app-nav-notas *ngIf="navItems[3].active"></app-nav-notas>
    
